import { Breadcrumbs, Chip, Link, Stack } from "@mui/material";
import HerbImage from "../../assets/doors/10_xpfp.jpeg";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { SiteRoutes } from "../../PageRouter";

export const Door10 = () => {
  const ingredients = [
    "Speisesalz",
    "Paprika",
    "schwarzer Pfeffer",
    "Zwiebel",
    "Petersilie",
    "Thymian",
    "Oregano",
    "Chili",
    "Rosmarin",
    "Koriander",
    "Basilikum",
    "Piment",
    "Knoblauch",
    "Majoran",
    "Estragon",
    "Lorbeer",
  ];

  const doorNr = 10;

  const shortDecription =
    'Wusstest du, dass...?\nGyros wird eigentlich "Jirosh" ausgesprochen. Im Griechischen ist das "G" stumm';

  const herbName = "Gyros";

  const recepieExample = (
    <Link
      target="_blank"
      rel="noopener noreferrer"
      href="https://emmikochteinfach.de/einfaches-gyros-rezept-wie-beim-griechen/#wprm-recipe-container-11515"
    >
      Einfaches Gyros Rezept - wie beim Griechen
    </Link>
  );

  const breadcrumb = (
    <Breadcrumbs maxItems={4} separator={<NavigateNextIcon fontSize="small" />}>
      <Link
        target="_blank"
        rel="noopener noreferrer"
        underline="hover"
        color="inherit"
        href="/"
      >
        Start
      </Link>
      {SiteRoutes.map((route) => {
        if (route.doorNumber && route.doorNumber <= doorNr) {
          return (
            <Link
              key={route.path}
              underline="hover"
              color="inherit"
              href={route.path}
            >
              Tag {route.doorNumber}
            </Link>
          );
        } else {
          return undefined;
        }
      })}
    </Breadcrumbs>
  );

  return (
    <>
      <img src={HerbImage} className="herb_img" alt="herb" />
      {breadcrumb}
      <h1 className="herb_name">{herbName}</h1>
      <i>{shortDecription}</i>
      <h3 className="content">Inhalt</h3>
      <div>
        <Stack
          spacing={1}
          direction="row"
          useFlexGap
          flexWrap="wrap"
          justifyContent="center"
        >
          {ingredients.map((ingredient, i) => {
            return (
              <Chip
                key={i}
                style={{ flexGrow: 1 }}
                label={ingredient}
                variant={i % 2 === 0 ? "filled" : "outlined"}
              />
            );
          })}
        </Stack>
      </div>
      <h3>Rezeptidee</h3>
      {recepieExample}
    </>
  );
};
